import * as yup from "yup";
import { validationSchemas } from "./data";
export const branchZoneSchema = yup.object().shape({
  zoneName: validationSchemas.name,
});
